<template>

  <div class="modal fade" id="myModal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">Exportera xlsx fil</h4>
        </div>
        <div class="modal-body">

            <h5>
                Välj kolumner att exportera
            </h5>
            <span v-on:click="massToggle()" v-if="toggleState == 1" class="excel-markall">Avmarkera alla</span>
            <span v-on:click="massToggle()" v-if="toggleState == 0" class="excel-markall">Markera alla</span>

          <div class="checkbox" v-for="(setting, key) in settings.exportFields">

            <label><input type="checkbox" v-bind:value="key" v-model="checkedNames">{{ setting.text }}</label>

          </div>

        </div>
        <div class="modal-footer">

          <transition name="loader-fade">
            <div style="display:inline-block; margin-right:20px; transform: translateY(7px);"><i class="fa fa-circle-o-notch fa-spin " style="font-size:24px; color:#00a870;" v-if="loading"></i></div>
          </transition>

          <button type="button" class="btn btn-default" data-dismiss="modal">Avbryt</button>
          <button type="button" class="btn btn-primary" :disabled="loading" v-on:click="triggerDownload()">Exportera</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios'

export default {

    props: {
        settings: {
            required: true
        },
        model: {
            required: true
        }

    },
    data: function () {
        return {
            checkedNames: [],
            toggleState: 1,
            loading: false
        }
    },

    watch: {

        settings: function () {
            const self = this

            if (self.settings.exportFields) {
                self.checkedNames = Object.keys(self.settings.exportFields)
            }
        }

    },

    methods: {

        triggerDownload: function () {
            if (this.loading) {
                return
            }

            this.loading = true

            const fields = this.checkedNames.join()

            axios({
                url: '/' + this.model + '/vueList/excel?fields=' + fields,
                method: 'GET',
                responseType: 'blob'
            }).then((response) => {
                const href = URL.createObjectURL(response.data)

                const filename = response.headers['content-disposition']
                    .split(';')
                    .find((n) => n.includes('filename='))
                    .replace('filename=', '')
                    .replaceAll('"', '')
                    .trim()

                const link = document.createElement('a')
                link.href = href
                link.setAttribute('download', filename)
                document.body.appendChild(link)
                link.click()

                document.body.removeChild(link)
                URL.revokeObjectURL(href)

                this.loading = false
            }).catch(err => {
                alert('Något gick fel, vänligen försök igen.')
                this.loading = false
            })
        },

        massToggle () {
            const self = this

            self.checkedNames = []

            if (self.toggleState == 0) {
                _.forEach(self.settings.exportFields, function (value, key) {
                    self.checkedNames.push(key)
                })
            }

            self.toggleState = 1 - self.toggleState
        }

    }

}

</script>
